export default __webpack_public_path__ + "static/media/techmarket-marker.9e7d0e01.png";